module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.1aea3f4d.svg";